import { useMatches } from '@tanstack/react-router';

export const useBreadcrumbs = () =>
    useMatches()
        .filter((d) => !d.staticData.excludeBreadcrumb)
        .map((match) => {
            const { context, loaderData } = match;
            const { localizeText } = context;

            const title =
                /**
                 * We should be able to use isMatch from @tanstack/react-router to narrow the match in the filter above.
                 * However, for whatever reason, the isMatch does not allow me to match `loaderData.title` here.
                 * Maybe we need to define the loaderData types somewhere? 🤷‍♂️
                 */
                (loaderData != null && 'title' in loaderData ? loaderData?.title?.() : undefined) ??
                (match.staticData.title !== undefined ? localizeText({ textKey: match.staticData.title }) : undefined);

            return {
                title,
                path: match.pathname,
            };
        })
        .filter((b) => b.title);
